export default function uploaderApiPath(scriptName) {
  const isLocalDev = window.location.hostname === "localhost" && window.location.port === "3000";
  if (isLocalDev) {
    return `http://localhost/wgio3/uploader/${scriptName}`;
  }
  return `./uploader/${scriptName}`;
}
